class NewsSlider {
    constructor($el) {
        this.$el = $el;

        this.options = {
            // autoPlay: true,
            pageDots: true,
            wrapAround: true,
            prevNextButtons: true,
            freeScroll: true,
            cellSelector: '.news-slider__slide',
            nextArrow: '<button class="any-class-name-you-want-next">Next</button>',
            prevArrow: '<button class="any-class-name-you-want-previous">Previous</button>'
        };

        if(this.$el.length) {
            this._createSlider();
        }
    }

    _createSlider() {
        this.$el.flickity(this.options);
    }
}

export default NewsSlider;
